import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  class: "grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5",
  role: "group",
  "aria-label": "Visões rápidas das solicitações",
  "data-testid": "activity-requests-quick-views"
}
const _hoisted_2 = ["aria-pressed", "data-testid", "onClick"]
const _hoisted_3 = { class: "text-xs font-bold text-neutral50" }
const _hoisted_4 = ["data-testid"]
const _hoisted_5 = { class: "text-[11px] text-neutral50" }

import { QUEUE_TONE_BORDER_CLASS } from '@/components/designSystem/QueueViews/types'
import type { ModuleViewCounters } from '@/components/designSystem/QueueViews/types'
import { ACTIVITY_REQUEST_QUICK_VIEWS } from '@/constants/activity-requests.constants'
import type { ActivityRequestQuickViewKey } from '@/types/activity-requests.types'


export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityRequestQuickViews',
  props: {
    counters: {},
    active: {},
    loading: { type: Boolean }
  },
  emits: ["select"],
  setup(__props: any, { emit }) {

const props = __props;





/** Sem contador (carregando ou falhou) é "—": um 0 inventado diria "tudo em dia". */
const countOf = (key: ActivityRequestQuickViewKey): string => {
  if (props.loading) return '…'
  const value = props.counters?.byView?.[key]
  return typeof value === 'number' ? value.toLocaleString('pt-BR') : '—'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ACTIVITY_REQUEST_QUICK_VIEWS), (view) => {
      return (_openBlock(), _createElementBlock("button", {
        key: view.key,
        type: "button",
        class: _normalizeClass(["flex flex-col items-start gap-0.5 rounded-lg border-2 border-t-4 border-solid px-3 py-2 text-left transition", [
        view.key === _ctx.active
          ? 'border-primary30 bg-primary5'
          : 'border-lightGray30 bg-white hover:bg-gray-50',
        _unref(QUEUE_TONE_BORDER_CLASS)[view.tone]
      ]]),
        "aria-pressed": view.key === _ctx.active,
        "data-testid": `activity-requests-quick-view-${view.key}`,
        onClick: ($event: any) => (emit('select', view.key))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(view.label), 1),
        _createElementVNode("span", {
          class: "text-2xl font-bold text-textPrimary",
          "data-testid": `activity-requests-quick-view-${view.key}-count`
        }, _toDisplayString(countOf(view.key)), 9, _hoisted_4),
        _createElementVNode("span", _hoisted_5, _toDisplayString(view.hint), 1)
      ], 10, _hoisted_2))
    }), 128))
  ]))
}
}

})